var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',{staticClass:"align-center"},[_c('span',{staticClass:"title text-capitalize"},[_vm._v("Nikah Connect")])]),_c('v-spacer'),_c('UserMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }